import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/footer";
import { IMAGES } from "../../constant/Image";
import Banner from "../../components/TitleBanner/index";
import { Link } from "react-router-dom";
import { cardData, categoryData } from "../../constant/fake-data";
import Button from "../../components/Button/index";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/index";
import { FaChevronRight } from "react-icons/fa6";

const HowToBid = () => {
  return (
    <div>
      <Header />

      <Banner
        title="How To Bid"
        bgImage={IMAGES.HowToBid_Banner_Bg}
        breadcrumbs={["How To Bid"]}
      />

      <section className="HowToBid-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="steps-box-main">
                <div className="inner-steps-box inner-steps-box-left">
                  <div className="text">
                    <h6>Step 01</h6>
                    <h5>Registration</h5>
                    <p>
                      Clearly state your pricing structure, payment terms and
                      and any additional charges. Specifying when & payment
                      invoices will be issued, as well as your accepted.
                    </p>
                  </div>
                  <div className="icon-box">
                    <FaChevronRight />
                  </div>
                </div>
                <div className="inner-steps-box inner-steps-box-right">
                  <div className="text">
                    <h6>Step 02</h6>
                    <h5>Browse Listings</h5>
                    <p>
                      Clearly state your pricing structure, payment terms and
                      and any additional charges. Specifying when & payment
                      invoices will be issued, as well as your accepted.
                    </p>
                  </div>
                  <div className="icon-box">
                    <FaChevronRight />
                  </div>
                </div>
                <div className="inner-steps-box inner-steps-box-left">
                  <div className="text">
                    <h6>Step 03</h6>
                    <h5>Place Bids</h5>
                    <p>
                      Clearly state your pricing structure, payment terms and
                      and any additional charges. Specifying when & payment
                      invoices will be issued, as well as your accepted.
                    </p>
                  </div>
                  <div className="icon-box">
                    <FaChevronRight />
                  </div>
                </div>
                <div className="inner-steps-box inner-steps-box-right">
                  <div className="text">
                    <h6>Step 04</h6>
                    <h5>Winning the Auction</h5>
                    <p>
                      Clearly state your pricing structure, payment terms and
                      and any additional charges. Specifying when & payment
                      invoices will be issued, as well as your accepted.
                    </p>
                  </div>
                  <div className="icon-box">
                    <FaChevronRight />
                  </div>
                </div>
                  <div className="inner-steps-box inner-steps-box-left">
                  <div className="text">
                    <h6>Step 05</h6>
                    <h5>Payment and Shipping</h5>
                    <p>
                      Clearly state your pricing structure, payment terms and
                      and any additional charges. Specifying when & payment
                      invoices will be issued, as well as your accepted.
                    </p>
                  </div>
                  <div className="icon-box">
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="guidelines-for-selling">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text">
                <h2>Guidelines For Selling</h2>
              </div>
              <div className="video-box">
                  <iframe
                        width="1250"
                        height="703"
                        src="https://www.youtube.com/embed/tUjIwYeVlQc"
                        title="BMW M3 G80 | CAP CUT | CAR EDIT | 4K"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
              </div>
            </div>
          </div>
        </div>

      </section>

      <Footer />
    </div>
  );
};

export default HowToBid;
